<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Manage Accounts</h4>
</div>
<div class="modal-body modal-xero-accounts">
  <h4>Selected Accounts</h4>

  <ng-template #customItemTemplate let-model="item" let-index="index">
    <div class="xero-accounts-item">
      <div class="name" title="{{ model.path }}">{{ model.Name }}</div>
      <div class="category">{{ model.Code }} {{ model.BankAccountType ? '|' : '' }} {{ model.BankAccountType }}</div>
    </div>
  </ng-template>

  <div class="options">
    <div class="options-items">
      <div *ngFor="let account of watchedAccounts">
        <div class="account-name">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM15.82 8.49C15.7265 8.39839 15.6009 8.34707 15.47 8.34707C15.3391 8.34707 15.2135 8.39839 15.12 8.49L10.38 13.23L8.88 11.74C8.83511 11.6922 8.7809 11.654 8.7207 11.628C8.6605 11.6019 8.5956 11.5885 8.53 11.5885C8.46441 11.5885 8.39951 11.6019 8.33931 11.628C8.27911 11.654 8.22489 11.6922 8.18 11.74L7.65 12.27C7.60314 12.3165 7.56594 12.3718 7.54056 12.4327C7.51517 12.4936 7.50211 12.559 7.50211 12.625C7.50211 12.691 7.51517 12.7564 7.54056 12.8173C7.56594 12.8782 7.60314 12.9335 7.65 12.98L10 15.35C10.0449 15.3978 10.0991 15.436 10.1593 15.462C10.2195 15.4881 10.2844 15.5015 10.35 15.5015C10.4156 15.5015 10.4805 15.4881 10.5407 15.462C10.6009 15.436 10.6551 15.3978 10.7 15.35L16.32 9.73C16.3669 9.68352 16.4041 9.62822 16.4295 9.56729C16.4548 9.50636 16.4679 9.44101 16.4679 9.375C16.4679 9.30899 16.4548 9.24364 16.4295 9.18271C16.4041 9.12178 16.3669 9.06648 16.32 9.02L15.82 8.49Z"
              fill="#2CC93C"
            />
          </svg>
          <div>{{ account.name }}</div>
        </div>
        <i
          class="feather trash color-red"
          style="cursor: pointer"
          (click)="removeAccountFromCompany(account.uuid)"
        ></i>
      </div>
    </div>
  </div>

  <input
    [(ngModel)]="selectedAccount.Name"
    [typeahead]="availableAccounts"
    typeaheadOptionField="Name"
    (typeaheadOnSelect)="selectAccount($event)"
    [typeaheadOptionsLimit]="9999"
    [typeaheadMinLength]="0"
    placeholder="Choose Account"
    class="form-control chevron"
    [typeaheadItemTemplate]="customItemTemplate"
  />

</div>
<div class="modal-footer">
  <button
    class="btn btn-primary"
    (click)="addAccountToCompany()"
  >
    Add account to company
  </button>

  <button class="btn" (click)="bsModalRef.hide()">Done</button>
</div>
